const InfoCardMultiple = ({ values, link, classes }) => {
  return (
    <>
      <div className='col-xl-3'>
        <div className={classes.cardClasses} href={link}>
        <div className='card-body pt-5 pb-5'>
            <div className={classes.titleClasses}>Licencias contratadas
            <div className='fw-semibold fs-1 text-gray-400'>
            <div className='d-flex align-items-center'>
            <span className="text-gray-900 fw-bolder">
            {values.licencia_contratadas}
                </span>
                </div>
                </div>
         
            </div>
          </div>
        </div>
      </div>
      <div className='col-xl-3'>
        <div className={classes.cardClasses} href={link}>
        <div className='card-body pt-5 pb-5'>
            <div className={classes.titleClasses}>Licencias utilizadas
            <div className='fw-semibold fs-1 text-gray-400'>
            <div className='d-flex align-items-center'>
            <span className="text-gray-900 fw-bolder">
                {values.licencia_utilizadas}
                </span>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div className='col-xl-3'>
        <div className={classes.cardClasses} href={link}>
        <div className='card-body pt-5 pb-5'>
            <div className={classes.titleClasses}>Notificaciones contratadas
            <div className='fw-semibold fs-1 text-gray-400'>
            <div className='d-flex align-items-center'>
            <span className="text-gray-900 fw-bolder">
            {values.notificaciones_contratadas}
                </span>
                </div>
                </div>
           
            </div>
          </div>
        </div>
      </div>
      <div className='col-xl-3'>
        <div className={classes.cardClasses} href={link}>
          <div className='card-body pt-5 pb-5'>
            <div className={classes.titleClasses}>Notificaciones utilizadas
            <div className='fw-semibold fs-1 text-gray-400'>
            <div className='d-flex align-items-center'>
            <span className="text-gray-900 fw-bolder">
            {values.notificaciones_utilizadas}
                </span>
                </div>
                </div>
          
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { InfoCardMultiple }
